import { render, staticRenderFns } from "./BaseStep.vue?vue&type=template&id=47aa0ad7&scoped=true&"
import script from "./BaseStep.vue?vue&type=script&lang=js&"
export * from "./BaseStep.vue?vue&type=script&lang=js&"
import style0 from "./BaseStep.vue?vue&type=style&index=0&id=47aa0ad7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47aa0ad7",
  null
  
)

export default component.exports